import '../../app-configuration/app-configuration.js';
import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';
import { Debouncer } from '@polymer/polymer/lib/utils/debounce.js';
import { timeOut } from '@polymer/polymer/lib/utils/async.js';

import '../google-map/google-map.js';
import '../katapult-auth/katapult-auth.js';
import '../katapult-toolbar/katapult-toolbar.js';
import { KatapultGeometry } from 'katapult-toolbox';
import '../katapult-elements/katapult-button.js';
import { KatapultDialog } from '../katapult-elements/katapult-dialog.js';

/* global Polymer, AppConfiguration, google */
class TSLMapsGenerator extends PolymerElement {
  static get template() {
    return html`
      <style include="paper-tooltip-style paper-menu-button-style">
        /* Front end menu CSS */
        /* General Layout */
        h1 {
          margin-bottom: 20px;
          border-bottom: 1px solid #b7b7b7;
          padding-bottom: 10px;
          font-size: 24pt;
          font-weight: 700;
          color: #6a6a6a;
        }
        h2 {
          color: #0053a0;
          border-bottom: 1px solid #d9d9d9;
          font-weight: 400;
          font-size: 20pt;
          margin-left: 40px;
          margin-right: 40px;
          margin-bottom: 5px;
        }
        h4 {
          margin-top: 20px;
          margin-bottom: 10px;
        }
        h6 {
          color: #999999;
          font-weight: 400;
          font-size: 11pt;
        }
        a:link {
          color: #00a4e6;
        }
        a:visited {
          color: #00a4e6;
        }
        a:hover {
          color: #00a4e6;
        }
        a:active {
          color: #f79100;
        }

        a.darkLink:link {
          color: #555;
        }
        a.darkLink:visited {
          color: #555;
        }
        a.darkLink:hover {
          color: #555;
        }
        a.darkLink:active {
          color: #00a4e6;
        }
        input,
        textarea,
        select {
          -webkit-transition: border 0.3s ease-in-out;
          -moz-transition: border 0.3s ease-in-out;
          -ms-transition: border 0.3s ease-in-out;
          -o-transition: border 0.3s ease-in-out;
          outline: none;
          height: 25px;
          margin-top: 1px;
          margin-bottom: 5px;
          /*padding: 3px 0px 3px 3px;
        margin: 5px 1px 3px 0px;*/
          border: 1px solid #d9d9d9;
        }
        input:focus,
        textarea:focus,
        select:focus {
          /*padding: 3px 0px 3px 3px;*/
          /*margin: 5px 1px 3px 0px;*/
          border: 1px solid #0053a0;
        }
        * {
          font-family: 'Source Sans Pro', sans-serif;
        }
        .center {
          float: left;
          width: 100%;
          text-align: center;
        }
        .button {
          text-decoration: none;
          color: white;
          font-size: 18px;
          background-color: #0053a0;
          text-align: center;
          display: inline-block;
          height: 45px;
          width: 210px;
          margin: 10px auto 10px auto;
          display: block;
          font-family: 'Source Sans Pro', sans-serif;
          cursor: pointer;
        }
        .button:hover {
          background-color: #003768;
        }
        .smallButton {
          padding: 0 15px 0 15px;
          height: 30px;
          font-size: 10pt;
          color: white;
          text-align: center;
          background-color: #0053a0;
        }
        .smallButton:hover {
          background-color: #003768;
        }
        .button:link {
          color: white;
        }
        .button:visited {
          color: white;
        }
        .button:hover {
          color: white;
        }
        .button:active {
          color: white;
        }
        /*Menu*/
        #contentWrapper {
          margin: 0 auto;
          width: 900px;
          margin-top: 20px;
        }
        #content {
          width: 860px;
          background-color: white;
          border: 1px solid #b7b7b7;
          float: left;
          padding: 20px;
          position: relative;
          z-index: 2;
        }
        #headerMargin {
          height: 40px;
          display: block;
        }
        #headerWrapper {
          margin: 0 auto;
          width: 845px;
          height: 111px;
        }
        #header {
          float: left;
          height: 60px;
          border-top: 1px dotted black;
          padding-top: 10px;
          text-align: center;
          position: relative;
        }
        #header a {
          text-decoration: none;
          font-size: 18px;
          font-weight: 400;
          color: #0053a0;
        }
        ul#nav {
          list-style: none;
          height: 50px;
          width: 700px;
          display: flex;
          justify-content: space-between;
        }
        ul#nav li {
          white-space: nowrap;
        }
        #signin {
          position: absolute;
          right: 0px;
          top: -28px;
        }
        #signin * {
          vertical-align: bottom;
        }
        #signin img {
          margin-left: 10px;
        }
        #userEmail {
          position: absolute;
          font-size: 10pt;
          color: #999;
          right: 110px;
          top: -20px;
        }
        #noScriptOverlay {
          top: 0;
          left: 0;
          background-color: rgba(0, 83, 160, 0.8);
          width: 100%;
          height: 100%;
          position: absolute;
          z-index: 100;
          display: table;
        }
        #noScriptWarning {
          color: white;
          font-size: 20px;
          display: table-cell;
          text-align: center;
          vertical-align: middle;
        }
        #footerWrapper {
          margin: 0 auto;
          width: 900px;
        }
        #footer {
          float: left;
          width: 850px;
          height: 73px;
          margin-top: 30px;
          margin-left: 26px;
          border-top: 1px dotted black;
          padding-top: 10px;
        }
        #footerLeft {
          float: left;
          text-decoration: none;
        }
        #footerRight {
          float: right;
          text-decoration: none;
        }
        #footerCenter {
          font-size: 10pt;
          text-align: center;
          color: #999;
          margin-top: 20px;
        }
        #windowMessage {
          position: fixed;
          display: table;
          z-index: 100;
          border: 1px solid #b7b7b7;
          width: 680px;
          height: 180px;
          padding: 10px;
          -webkit-transition: opacity 0.3s;
          -moz-transition: opacity 0.3s;
          -ms-transition: opacity 0.3s;
          -o-transition: opacity 0.3s;
        }
        #windowMessage h4 {
          display: table-row;
          height: 50px;
          font-size: 2em;
        }
        #windowMessageText {
          display: table-cell;
          vertical-align: middle;
          text-align: center;
          font-size: 1.5em;
          border-top: 1px solid #b7b7b7;
        }
        #windowDialog {
          position: fixed;
          z-index: 100;
          border: 1px solid #b7b7b7;
          width: 680px;
          padding-top: 10px;
          padding-bottom: 10px;
          -webkit-transition: opacity 0.3s;
          -moz-transition: opacity 0.3s;
          -ms-transition: opacity 0.3s;
          -o-transition: opacity 0.3s;
        }
        #windowDialog h2 {
          margin-bottom: 0;
        }
        #windowDialogX {
          position: absolute;
          display: inline;
          top: 10px;
          right: 10px;
          width: 18px;
          height: 18px;
          cursor: pointer;
        }
        #windowDialogTitle2 {
          border-bottom: none;
        }
        #windowDialogText {
          margin-left: 50px;
          margin-top: 10px;
          width: 580px;
        }
        #windowDialog label {
          display: block;
          width: 100%;
          text-align: center;
          margin-top: 20px;
          margin-bottom: 20px;
        }
        #windowDialogCheckBox {
          height: auto;
          margin-right: 10px;
        }
        #windowDialogLoader {
          width: 32px;
          height: 32px;
          display: block;
          margin: 20px auto 20px auto;
        }
        #windowDialog .button {
          float: left;
          margin-left: 20px;
          width: 250px;
        }
        .orangeButton {
          background-color: #f79100;
        }
        .orangeButton:hover {
          background-color: #a15e00;
        }
        #lightBox {
          z-index: 10;
          position: fixed;
          background-color: rgb(14, 14, 14);
          opacity: 0.7;
          -ms-filter: 'progid:DXImageTransform.Microsoft.Alpha(Opacity=70)';
          filter: alpha(opacity=70);
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          -webkit-transition: opacity 0.3s;
          -moz-transition: opacity 0.3s;
          -ms-transition: opacity 0.3s;
          -o-transition: opacity 0.3s;
        }
        #pplLogo {
          position: absolute;
          top: -35px;
          right: -145px;
        }
        #emailRecipient {
          float: left;
          width: 100%;
          border-bottom: 1px solid #b1b1b1;
          margin-top: 20px;
        }
        #emailTo {
          float: left;
          width: 5%;
          margin-top: 2px;
        }
        #emailRecipientInput {
          float: left;
          width: 95%;
          border: none;
          font-size: 16px;
          margin: 0;
        }
        #emailRecipientInput:focus {
          box-shadow: none;
        }
        #emailSender {
          margin-top: 2px;
          float: left;
          height: 25px;
          cursor: default;
        }
        #emailSubject {
          float: left;
          width: 100%;
          border-top: 1px solid #b1b1b1;
        }
        #emailSub {
          float: left;
          width: 9%;
          margin-top: 2px;
        }
        #emailSubjectInput {
          float: left;
          width: 91%;
          border: none;
          font-size: 16px;
          margin: 0;
        }
        #emailSubjectInput:focus {
          box-shadow: none;
        }
        #emailBody {
          border: none;
          border-top: 1px solid #ccc;
          width: 100%;
          height: 450px;
          resize: none;
          font-size: 16px;
        }
        #emailBody:focus {
          box-shadow: none;
        }
        #emailX {
          position: absolute;
          top: 10px;
          right: 10px;
          height: 18px;
          width: 18px;
          cursor: pointer;
        }
        #downTimeWarning {
          display: none;
          background-color: #f79100;
          color: #0053a0;
          float: left;
          padding: 3px;
          border-radius: 3px;
          width: 895px;
          margin: -15px 0 20px -27px;
          text-align: center;
        }
        #footerCompanyArea {
          display: inline-block;
          margin-top: -20px;
        }
        #footerKatapult {
          float: left;
        }
        #footerPPL {
          float: left;
        }
        #footerLogoSpacer {
          background-image: url(https://storage.googleapis.com/katapult-pro-shared-files/photos/tsl-maps/squairy_light.png);
          margin-top: -27px;
          float: left;
        }
        #footerLogo {
          background-image: url(https://storage.googleapis.com/katapult-pro-shared-files/photos/tsl-maps/katapult_white_badge_55x64.png);
          background-repeat: no-repeat;
          width: 55px;
          height: 64px;
          margin-left: 10px;
          margin-right: 10px;
        }
        #footerLogo:hover {
          background-image: url(https://storage.googleapis.com/katapult-pro-shared-files/photos/tsl-maps/katapult_ppl_two_tone_badge_55x64.png);
        }
        /* End Front end menu CSS */

        #searchArea {
          background-color: #efefef;
          width: 100%;
          box-sizing: border-box;
          height: 40px;
          padding: 5px;
          color: #999;
          border: 1px solid #d9d9d9;
          display: inline-block;
          margin-bottom: 10px;
        }
        #searchBox {
          height: 100%;
          width: 85%;
          box-sizing: border-box;
          float: left;
          padding-left: 5px;
          margin: 0;
        }
        #searchBox:focus {
          box-shadow: none;
        }
        #search {
          float: left;
          height: 100%;
          box-sizing: border-box;
          width: 15%;
          margin: 0;
          font-size: 12pt;
        }
        #mapCanvasContainer {
          width: 100%;
          margin-left: -20px;
          margin-right: -20px;
        }
        #mapCanvas {
          height: 550px;
          margin: 0 -18px -18px -18px;
        }
        #mapMenu {
          background-color: white;
          position: absolute;
          top: 250px;
          right: 100%;
          width: 40px;
          padding: 0 10px 10px 10px;
          margin-right: 1px;
        }
        .mapMenuButton {
          width: 100%;
          margin-top: 10px;
          cursor: pointer;
        }
        #messageArea {
          position: relative;
          left: 100%;
          margin-left: 21px;
          height: 100%;
        }
        #messageContainer {
          position: absolute;
          bottom: 0;
        }
        .mapMessage {
          background-color: white;
          color: #999;
          padding: 10px;
          margin-top: 10px;
          margin-bottom: -75px;
          opacity: 0;
          display: table;
          -webkit-transition:
            margin-bottom 0.3s ease-in-out,
            opacity 0.3s ease-in-out;
          -moz-transition:
            margin-bottom 0.3s ease-in-out,
            opacity 0.3s ease-in-out;
          -ms-transition:
            margin-bottom 0.3s ease-in-out,
            opacity 0.3s ease-in-out;
          -o-transition:
            margin-bottom 0.3s ease-in-out,
            opacity 0.3s ease-in-out;
        }
        .mapMessageText {
          display: inline-block;
          width: 250px;
        }
        .mapMessageIcon {
          display: inline-block;
        }

        /* Out of date warning banner */
        div.warning-banner {
          padding: 10px;
          border-radius: 5px;
          color: white;
          background: orange;
          font-weight: bold;
        }
        .warning-banner span {
          margin-right: 10px;
        }
        .warning-banner a {
          color: white;
          text-decoration: underline;
          cursor: pointer;
        }
      </style>

      <div id="messageContent"></div>
      <katapult-auth
        user="{{user}}"
        user-group="{{userGroup}}"
        signed-in="{{signedIn}}"
        read-only="{{readOnlyUser}}"
        title="[[config.firebaseData.name]] TSL Maps"
        no-signup="[[!config.firebaseData.offerLicenses]]"
        on-sign-in="onSignIn"
      >
        <div slot="title-content">
          <p style="margin: 0;">[[config.firebaseData.name]] TSL Maps</p>
        </div>
        <div slot="description-content">
          <p>Relocating poles for a PennDOT or Turnpike project?</p>
          <p>
            [[config.firebaseData.name]] TSL Map Generator allows you to download Type Size and Location Maps for all PPL Faclities in a
            given location.
          </p>
          <p>
            Need some help? View our
            <a
              target="_blank"
              href="https://storage.googleapis.com/katapult-pro-shared-files/blobs/tsl-maps/PennDOT_Relocations_Creating_a_TSL_Map.pdf"
              style="color: white; font-weight: normal; text-decoration: none;"
              >Tutorial</a
            >
          </p>
        </div>
        <div slot="sign-up-form" style="display:flex; flex-direction:column;">
          <paper-input label="Email" value="{{email}}" error-message="[[emailError]]" invalid="[[emailError]]" tab-index="1"></paper-input>
          <paper-input id="companyName" label="Company Name" value="{{companyName}}" tab-index="2"></paper-input>
          <katapult-button on-click="signUpRequest" style="margin:16px 0;" loading="[[signupWaiting]]" color="var(--secondary-color)"
            >Request Access</katapult-button
          >
        </div>
        <div slot="auth-content">
          <template is="dom-if" if="{{!userHasAccess(hasTSLMapsAccess)}}">
            <template is="dom-if" if="{{showNoAccessMessage}}">
              <div style="text-align:center;">
                <br />
                <br />
                <br />
                <h1>You don't have access to this page</h1>
              </div>
            </template>
          </template>
          <template is="dom-if" if="{{userHasAccess(hasTSLMapsAccess)}}">
            <katapult-toolbar id="toolbar" style="flex-shrink: 0;" user-group="[[userGroup]]">
              <div slot="left" style="font-size: 20pt; font-weight: 700; color: #6a6a6a;">Generate TSL Map</div>
              <div slot="center">
                <div class="warning-banner">
                  <span>Warning: The data in these maps are out of date.</span>
                  <a on-click="showOutOfDateWarningDialog">Learn More</a>
                </div>
              </div>
            </katapult-toolbar>

            <div id="contentWrapper">
              <div id="content">
                <div id="searchArea">
                  <input
                    id="searchBox"
                    placeholder="to get started, enter a ppl grid number, address, town name, or gps coordinates to zoom to the work area"
                  />
                  <input id="search" type="submit" value="Search" class="button" />
                </div>
                <div id="mapCanvas">
                  <google-map
                    id="googlemap"
                    api-key="[[apiKey]]"
                    api-channel="PPL TSL Maps"
                    latitude="{{latitude}}"
                    longitude="{{longitude}}"
                    zoom="{{zoom}}"
                    max-zoom="30"
                    on-google-map-ready="googleMapReady"
                    map="{{map}}"
                  >
                    <slot name="markers" slot="markers"></slot>
                  </google-map>
                </div>
                <div id="mapMenu">
                  <img
                    id="drawLines"
                    src="https://storage.googleapis.com/katapult-pro-shared-files/photos/tsl-maps/TSL_Draw_Map_Lines.png"
                    class="mapMenuButton"
                  />
                  <img
                    id="createPDF"
                    src="https://storage.googleapis.com/katapult-pro-shared-files/photos/tsl-maps/TSL_Create_PDF.png"
                    class="mapMenuButton"
                  />
                </div>
                <div id="messageArea">
                  <div id="messageContainer"></div>
                </div>
              </div>
            </div>
            <div id="footerWrapper">
              <div id="footer">
                <a
                  id="footerLeft"
                  target="_blank"
                  href="https://docs.google.com/a/stineconsulting.com/forms/d/1Qt05ILE6Jtv9GvtJ5W8CmLMJ-PzaYc8M6zF_r78Jhrg/viewform"
                  >Report a problem</a
                ><a id="footerRight" href="https://katapultengineering.com/contact">Contact Us</a>
                <div id="footerCenter">
                  <div id="footerCompanyArea">
                    <div id="footerPPL">PPLEU Corp 2019</div>
                    <div id="footerLogoSpacer">
                      <div id="footerLogo"></div>
                    </div>
                    <div id="footerKatapult">Katapult® 2019</div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </katapult-auth>
    `;
  }

  static get is() {
    return 'tsl-maps-generator';
  }
  static get properties() {
    return {
      geocoder: {
        type: Object,
        value: null
      },
      user: {
        type: Object
      },
      map: {
        type: Object,
        value: null
      },
      latitude: {
        type: Number,
        value: 40.601423
      },
      longitude: {
        type: Number,
        value: -75.476206
      },
      zoom: {
        type: Number,
        value: 18
      },
      drawLinesMode: {
        type: Boolean,
        value: false
      },
      polyLines: {
        type: Array,
        value: () => []
      },
      newPolyLine: {
        type: Boolean,
        value: true
      },
      increment: {
        type: Number,
        value: 0
      },
      generatedMaps: {
        type: Boolean,
        value: false
      },
      dialogCallback: {
        type: Object,
        value: null
      },
      leftClickListener: {
        type: Object,
        value: null
      },
      rightClickListener: {
        type: Object,
        value: null
      },
      mapErrorTimeout: {
        type: Object,
        value: null
      },
      tooLongMessageTimeout: {
        type: Object
      }
    };
  }
  constructor() {
    super();
    this.config = config;
    this.apiKey = config.mapsApiKey;
  }
  static get observers() {
    return ['checkAccess(user, userGroup)'];
  }

  ready() {
    super.ready();
    this.appConfiguration = new AppConfiguration(this);
  }

  showOutOfDateWarningDialog() {
    KatapultDialog.alert(
      `Due to changes to PPL's GIS configuration some wire data is out of date. These maps are useful for preliminary decisions, but field inspections and PA One Calls are expected to be used for final decision making. We are working hard with PPL to update wire data to help you plan better in the future.`,
      `Warning`,
      `var(--paper-orange-500)`
    );
  }

  onSignIn() {
    this.showOutOfDateWarningDialog();
  }

  async checkAccess() {
    if (this.user && this.userGroup) {
      this.hasTSLMapsAccess = await FirebaseWorker.ref(`users/${this.userGroup}/${this.user.uid}/workflows/tsl_maps`)
        .once('value')
        .then((s) => s.val());
    } else {
      this.hasTSLMapsAccess = false;
      setTimeout(() => {
        this.showNoAccessMessage = true;
      }, 1000);
    }
  }

  googleMapReady() {
    this.map.setOptions({
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
        mapTypeIds: ['Map', google.maps.MapTypeId.HYBRID]
      },
      panControlOptions: {
        position: google.maps.ControlPosition.RIGHT_TOP
      },
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_TOP
      },
      streetViewControlOptions: {
        position: google.maps.ControlPosition.RIGHT_TOP
      }
    });

    var pointsOfInterestOffStyle = [
      {
        featureType: 'poi',
        stylers: [{ visibility: 'off' }]
      }
    ];
    var pointsOfInterestOffMap = new google.maps.StyledMapType(pointsOfInterestOffStyle, { name: 'Map' });
    this.map.mapTypes.set('Map', pointsOfInterestOffMap);
    this.map.setMapTypeId('Map');

    this.geocoder = new google.maps.Geocoder();
  }

  userHasAccess(hasTSLMapsAccess) {
    if (hasTSLMapsAccess === true) {
      this._debouncer = Debouncer.debounce(this._debouncer, timeOut.after(1000), () => {
        this.start();
      });
    }
    return hasTSLMapsAccess === true;
  }

  start() {
    this.addEventHandler(this.shadowRoot.querySelector('#search'), 'click', this.searchForLocation.bind(this));
    var searchBox = this.shadowRoot.querySelector('#searchBox');
    this.addEventHandler(searchBox, 'keyup', (e) => {
      e = e || window.event;
      if (e.keyCode == 13) {
        this.searchForLocation();
      }
    });
    searchBox.focus();
    this.addEventHandler(this.shadowRoot.querySelector('#drawLines'), 'click', this.drawLinesToggle.bind(this));
    this.addEventHandler(this.shadowRoot.querySelector('#createPDF'), 'click', this.generatePDF.bind(this));
    this.showMapMessage('Use the search box to zoom to the area of your TSL map.');
  }

  addEventHandler(element, eventType, handler) {
    if (typeof element == 'string') element = document.getElementById(element);
    if (element == null) return;
    if (element.addEventListener) {
      if (eventType == 'mousewheel') element.addEventListener('DOMMouseScroll', handler, false);
      element.addEventListener(eventType, handler, false);
    } else if (element.attachEvent) element.attachEvent('on' + eventType, handler);
  }

  removeEventHandler(element, eventType, handler) {
    if (typeof element == 'string') element = document.getElementById(element);
    if (element == null) return;
    if (element.removeEventListener) {
      if (eventType == 'mousewheel') element.removeEventListener('DOMMouseScroll', handler, false);
      element.removeEventListener(eventType, handler, false);
    } else if (element.detachEvent) element.detachEvent('on' + eventType, handler);
  }

  newXHR() {
    if (window.XMLHttpRequest) {
      return new XMLHttpRequest();
    } else if (window.ActiveXObject) {
      return new ActiveXObject('Microsoft.XMLHTTP');
    } else {
      this.showWindowMessage(
        "AJAX Requests are disabled. This site won't work without them. Check your security settings, or call us at 717 432 0716.",
        '#f79100'
      );
    }
  }

  getDisplayMsg(resultObject) {
    var display_msg = '';
    if (typeof resultObject === 'string') {
      display_msg = resultObject;
    } else if (resultObject.hasOwnProperty('message')) {
      for (var i = 0; i < resultObject.message.length; i++) {
        if (i > 0) {
          display_msg += ' ';
        }
        display_msg += resultObject.message[i].display_msg;
      }
    } else {
      display_msg = resultObject.display_msg;
    }
    return display_msg;
  }

  showWindowMessage(text, color, leaveHash, preventClose) {
    var messageDiv = document.createElement('div');
    messageDiv.id = 'windowMessage';
    messageDiv.leaveHash = leaveHash;
    messageDiv.style.left = (document.body.clientWidth - 702) / 2 + 'px';
    messageDiv.style.top = (document.documentElement.clientHeight - 200) / 2 + 'px';
    messageDiv.style.backgroundColor = color;
    messageDiv.style.color = 'white';
    var header = document.createElement('h4');
    header.innerHTML = 'Response Message:';
    messageDiv.appendChild(header);
    var textDiv = document.createElement('div');
    textDiv.id = 'windowMessageText';
    var mess = this.getDisplayMsg(text);
    textDiv.innerHTML = mess;
    messageDiv.appendChild(textDiv);
    if (!preventClose) {
      var xDiv = document.createElement('img');
      xDiv.id = 'windowDialogX';
      if (document.all) {
        xDiv.src = 'https://storage.googleapis.com/katapult-pro-shared-files/photos/tsl-maps/white_X-sign.png';
      } else {
        xDiv.src = 'https://storage.googleapis.com/katapult-pro-shared-files/photos/tsl-maps/white_X-sign.svg';
      }
      messageDiv.appendChild(xDiv);
    }

    var lightBox = document.createElement('div');
    lightBox.id = 'lightBox';
    this.shadowRoot.querySelector('#messageContent').appendChild(lightBox);

    this.shadowRoot.querySelector('#messageContent').appendChild(messageDiv);
    if (!preventClose) {
      this.addEventHandler(document, 'click', this.removeMessage.bind(this));
    }
  }

  removeMessage(e) {
    this.removeEventHandler(document, 'click', this.removeMessage);
    var message = this.shadowRoot.querySelector('#windowMessage');
    if (message != null) {
      if (!message.leaveHash) {
        window.location.hash = '';
      }
      message.style.opacity = '0';
      var lightBox = this.shadowRoot.querySelector('#lightBox');
      lightBox.style.opacity = '0';
      if (
        message.style['-webkit-transition'] !== undefined ||
        message.style['-moz-transition'] !== undefined ||
        message.style['-ms-transition'] !== undefined ||
        message.style['-o-transition'] !== undefined
      ) {
        setTimeout(() => {
          message.parentNode.removeChild(message);
          lightBox.parentNode.removeChild(lightBox);
        }, 1000);
      } else {
        message.parentNode.removeChild(message);
        lightBox.parentNode.removeChild(lightBox);
      }
    }
  }

  signUpRequest(e) {
    // Clear errors.
    this.emailError = '';
    // Sanitize Email.
    this.email = katapultAuth._sanitizeEmail(this.email);
    this.emailError = katapultAuth._validateEmail(this.email);
    var error = !!this.emailError;
    if (!this.companyName) {
      error = true;
      this.$.companyName.setAttribute('invalid', true);
    } else {
      this.$.companyName.removeAttribute('invalid');
    }
    if (!error) {
      var request = {
        email: this.email,
        companyName: this.companyName,
        template: 'tslSignup'
      };
      this.signupWaiting = true;
      firebase
        .functions()
        .httpsCallable('email')(request)
        .then((res) => {
          this.signupWaiting = false;
          this.showWindowMessage('Request for Access sent. Expect an email response in the next few days.', '#0053a0');
          katapultAuth.activeForm = 'signInForm';
        })
        .catch((err) => {
          console.log(err);
          this.signupWaiting = false;
          let message = err.message.toLowerCase() == 'internal' ? 'Please Contact the owner of this site.' : err.message;
          this.showWindowMessage('Error Creating Account - ' + message, '#f79100');
        });
    }
  }

  async searchForLocation() {
    var searchBox = this.shadowRoot.querySelector('#searchBox');

    if (searchBox && searchBox.value) {
      // Check if the search is a grid number
      let gridNumber = searchBox.value.toUpperCase().trim();

      if (/^\d{5}(N|S)\d{5}$/.test(gridNumber)) {
        let poleContextLayer = (await firebase.database().ref(`photoheight/white_label/contextLayers/poles`).once('value')).val();
        firebase
          .app()
          .database(`https://${poleContextLayer.database}.firebaseio.com`)
          .ref(`${poleContextLayer.url}/${gridNumber}`)
          .once('value')
          .then((s) => {
            let coordinates = null;
            let poleData = s.val();

            // If there is pole data, then use that coordinate
            if (poleData && poleData.l && poleData.l.length == 2) {
              // Set the coordinated based off of the pole data
              coordinates = {
                lat: poleData.l[0],
                long: poleData.l[1]
              };
            } else {
              // Otherwise, estimate the location

              // Get the first 5 digits
              let x = gridNumber.substring(0, 5);
              // Get the last 5 digits
              let y = gridNumber.substring(6);
              // Get the middle character
              let region = gridNumber.substring(5, 6);

              // Convert x and y
              x = x * 10 + 2000000;
              y = y * 10;

              let PANorth =
                '+proj=lcc +lat_1=40.88333333333333 +lat_2=41.95 +lat_0=40.16666666666666 +lon_0=-77.75 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs';
              let PASouth =
                '+proj=lcc +lat_1=39.93333333333333 +lat_2=40.8 +lat_0=39.33333333333334 +lon_0=-77.75 +x_0=609601.2192024384 +y_0=0 +datum=NAD27 +units=us-ft +no_defs';

              let srid = PANorth;
              if (region == 'S') srid = PASouth;

              coordinates = KatapultGeometry.XyToLatLong(x, y, srid);
            }

            if (coordinates) {
              this.map.setCenter(new google.maps.LatLng(coordinates.lat, coordinates.long));
              this.map.setZoom(18);
              this.clearMessages();
              this.showMapMessage(
                'Click the draw line icon to draw along the roads where you need a TSL map',
                'https://storage.googleapis.com/katapult-pro-shared-files/photos/tsl-maps/TSL_Draw_Map_Lines.png'
              );
            } else {
              this.showWindowMessage('There was an error getting the coordinates for the entered Grid Number.', '#f79100');
            }
          });
      } else {
        // Otherwise, try to geocode the search
        this.geocoder.geocode({ address: searchBox.value }, (results, status) => {
          if (status == google.maps.GeocoderStatus.OK) {
            searchBox.value = results[0].formatted_address;
            this.map.setCenter(results[0].geometry.location);
            this.map.setZoom(18);
            this.clearMessages();
            this.showMapMessage(
              'Click the draw line icon to draw along the roads where you need a TSL map',
              'https://storage.googleapis.com/katapult-pro-shared-files/photos/tsl-maps/TSL_Draw_Map_Lines.png'
            );
          } else {
            this.clearMessages();
            this.showMapMessage('Unsuccessful search for the following reason: ' + status);
            clearTimeout(this.mapErrorTimeout);
            this.mapErrorTimeout = setTimeout(() => {
              this.clearMessages();
              this.showMapMessage('Use the search box to zoom to the area of your TSL map.');
            }, 3000);
          }
        });
      }
    } else {
      this.showWindowMessage('Please enter a valid search.', '#f79100');
    }
  }

  showWindowDialog(title1, title2, text, checkbox, yesText, noText, isYesDeletion, callback) {
    var messageDiv = document.createElement('div');
    this.addEventHandler(messageDiv, 'click', (e) => {
      e = e || window.event;
      if (e.stopPropagation) {
        e.stopPropagation();
      } else {
        e.cancelBubble = true;
      }
    });
    messageDiv.id = 'windowDialog';
    messageDiv.style.left = (document.body.clientWidth - 722) / 2 + 'px';
    messageDiv.style.top = (document.documentElement.clientHeight - 307) / 2 + 'px';
    messageDiv.style.backgroundColor = 'white';
    var contentDiv = document.createElement('div');
    contentDiv.id = 'dialogContent';
    var titleDiv = document.createElement('h2');
    titleDiv.id = 'windowDialogTitle';
    titleDiv.innerHTML = title1;
    messageDiv.appendChild(titleDiv);
    if (title2 != null) {
      var titleDiv2 = document.createElement('h2');
      titleDiv2.id = 'windowDialogTitle2';
      titleDiv2.innerHTML = title2;
      contentDiv.appendChild(titleDiv2);
    }
    if (yesText != null || noText != null) {
      var xDiv = document.createElement('img');
      this.addEventHandler(xDiv, 'click', (e) => {
        this.removeDialog();
        callback(false);
      });
      xDiv.id = 'windowDialogX';
      if (document.all) {
        xDiv.src = 'https://storage.googleapis.com/katapult-pro-shared-files/photos/tsl-maps/dark-blue-X-sign.png';
      } else {
        xDiv.src = 'https://storage.googleapis.com/katapult-pro-shared-files/photos/tsl-maps/dark-blue-X-sign.svg';
      }
      contentDiv.appendChild(xDiv);
    }
    var textDiv = document.createElement('div');
    textDiv.id = 'windowDialogText';
    textDiv.innerHTML = text;
    contentDiv.appendChild(textDiv);

    if (checkbox != null) {
      var label = document.createElement('label');
      var checkboxDiv = document.createElement('input');
      checkboxDiv.id = 'windowDialogCheckBox';
      checkboxDiv.type = 'checkbox';
      checkboxDiv.name = 'confirm';
      label.appendChild(checkboxDiv);
      var labelText = document.createTextNode(checkbox);
      label.appendChild(labelText);
      contentDiv.appendChild(label);
    }

    var yesButton = document.createElement('input');
    yesButton.className = 'button';
    yesButton.type = 'submit';
    yesButton.style.height = 'auto';
    yesButton.style.paddingTop = '10px';
    yesButton.style.paddingBottom = '10px';
    yesButton.style.lineHeight = '20px';
    yesButton.value = yesText;
    this.addEventHandler(yesButton, 'click', (e) => {
      if (checkbox) {
        if (checkboxDiv.checked) {
          callback(true);
        } else {
          var asterisk = document.createElement('span');
          asterisk.innerHTML = '*';
          asterisk.style.color = '#f79100';
          label.appendChild(asterisk);
        }
      } else {
        callback(true);
      }
    });

    var noButton = document.createElement('input');
    noButton.className = 'button';
    noButton.type = 'submit';
    noButton.style.height = 'auto';
    noButton.style.paddingTop = '10px';
    noButton.style.paddingBottom = '10px';
    noButton.style.lineHeight = '20px';
    noButton.value = noText;
    this.addEventHandler(noButton, 'click', (e) => {
      this.removeDialog();
      callback(false);
    });

    if (noText == null) {
      yesButton.style.width = '640px';
    } else if (isYesDeletion) {
      yesButton.className = yesButton.className + ' orangeButton';
      noButton.style.width = '370px';
    } else {
      noButton.className = noButton.className + ' orangeButton';
      yesButton.style.width = '370px';
    }
    if (yesText != null) {
      contentDiv.appendChild(yesButton);
    }
    if (noText != null) {
      contentDiv.appendChild(noButton);
    }
    var lightBox = document.createElement('div');
    lightBox.id = 'lightBox';
    this.shadowRoot.querySelector('#contentWrapper').appendChild(lightBox);
    messageDiv.appendChild(contentDiv);
    this.shadowRoot.querySelector('#contentWrapper').appendChild(messageDiv);
    var clientHeight = messageDiv.clientHeight;
    if (clientHeight != null && clientHeight != 0) {
      messageDiv.style.top = (document.documentElement.clientHeight - clientHeight) / 2 + 'px';
    }
    this.dialogCallback = callback;
  }

  removeDialog(e) {
    if (this.removeDialog) this.removeEventHandler(document, 'click', this.removeDialog);
    var message = this.shadowRoot.querySelector('#windowDialog');
    if (message != null) {
      message.style.opacity = '0';
      var lightBox = this.shadowRoot.querySelector('#lightBox');
      lightBox.style.opacity = '0';
      if (
        message.style['-webkit-transition'] !== undefined ||
        message.style['-moz-transition'] !== undefined ||
        message.style['-ms-transition'] !== undefined ||
        message.style['-o-transition'] !== undefined
      ) {
        setTimeout(() => {
          message.parentNode.removeChild(message);
          lightBox.parentNode.removeChild(lightBox);
        }, 1000);
      } else {
        message.parentNode.removeChild(message);
        lightBox.parentNode.removeChild(lightBox);
      }
    }
  }

  setDialogToLoader(titleText, messageText) {
    if (this.removeDialog) this.removeEventHandler(document, 'click', this.removeDialog);
    var dialog = this.shadowRoot.querySelector('#windowDialog');
    dialog.removeChild(this.shadowRoot.querySelector('#dialogContent'));
    var textDiv = this.shadowRoot.querySelector('#windowDialogTitle');
    textDiv.innerHTML = titleText;

    if (messageText != null) {
      var windowDialogText = document.createElement('div');
      windowDialogText.id = 'windowDialogText';
      windowDialogText.innerHTML = messageText;
      dialog.appendChild(windowDialogText);
    }

    var loading = document.createElement('img');
    loading.id = 'windowDialogLoader';
    loading.src = 'https://storage.googleapis.com/katapult-pro-shared-files/photos/tsl-maps/ajax-loader.gif';
    loading.width = '32px';
    loading.height = '32px';
    dialog.appendChild(loading);
  }

  drawLinesToggle(e) {
    if (this.drawLinesMode) {
      this.turnOffDrawLines();
    } else {
      if (this.generatedMaps) {
        this.showWindowDialog(
          'Do you want to clear your previous lines?',
          '',
          'The lines from your last map are still there. Would you like clear them to start fresh on a new map?',
          null,
          'Yes, clear lines.',
          'No, keep them.',
          true,
          (doIt) => {
            if (doIt) {
              for (var i = 0; i < this.polyLines.length; i++) {
                this.polyLines[i].setMap(null);
              }
              this.polyLines = [];
            }
            this.removeDialog();
            this.turnOnDrawLines();
          }
        );
        if (e.stopPropagation) {
          e.stopPropagation();
        } else {
          e.cancelBubble = true;
        }
      } else {
        this.turnOnDrawLines();
      }
    }
  }

  turnOnDrawLines() {
    this.drawLinesMode = true;
    this.map.setOptions({
      draggableCursor: 'crosshair',
      draggingCursor: 'crosshair'
    });
    this.leftClickListener = google.maps.event.addListener(this.map, 'click', this.clickMap.bind(this));
    this.rightClickListener = google.maps.event.addListener(this.map, 'rightclick', this.rightClickMap.bind(this));
    this.clearMessages();
    this.showMapMessage('Click the map to add points to your line, right click the map or click the draw line icon to end your line.');
    this.showMapMessage('If there are multiple areas in the scope of the TSL, you can add as many lines as you need.');
  }

  turnOffDrawLines() {
    this.drawLinesMode = false;
    this.newPolyLine = true;
    this.map.setOptions({
      draggableCursor: null,
      draggingCursor: null
    });
    google.maps.event.removeListener(this.leftClickListener);
    google.maps.event.removeListener(this.rightClickListener);
    this.clearMessages();
    if (this.polyLines.length == 0) {
      this.showMapMessage(
        'Click the draw line icon to draw along the roads where you need a TSL map',
        'https://storage.googleapis.com/katapult-pro-shared-files/photos/tsl-maps/TSL_Draw_Map_Lines.png'
      );
    } else {
      this.showMapMessage(
        'Click the draw line icon to add any additional lines you need in the TSL map',
        'https://storage.googleapis.com/katapult-pro-shared-files/photos/tsl-maps/TSL_Draw_Map_Lines.png'
      );
      this.showMapMessage(
        'When you are finished, click the pdf button to generate your TSL map.',
        'https://storage.googleapis.com/katapult-pro-shared-files/photos/tsl-maps/TSL_Create_PDF.png'
      );
    }
  }

  clickMap(e) {
    if (this.newPolyLine) {
      this.newPolyLine = false;
      var polyOptions = {
        strokeColor: '#FF0000',
        strokeOpacity: 0.6,
        strokeWeight: 10,
        editable: true
      };
      var poly = new google.maps.Polyline(polyOptions);
      poly.setMap(this.map);
      poly.getPath().push(e.latLng);
      this.polyLines.push(poly);
    } else {
      this.polyLines[this.polyLines.length - 1].getPath().push(e.latLng);
      var length = 0;
      for (var i = 0; i < this.polyLines.length; i++) {
        length += google.maps.geometry.spherical.computeLength(this.polyLines[i].getPath());
      }
      if (length > 4828.02) {
        setTimeout(() => {
          this.showWindowDialog(
            'TSL maps are limited in length.',
            '',
            'Please limit your use, or generate a second map.',
            null,
            'Ok',
            null,
            true,
            (doIt) => {
              this.polyLines[this.polyLines.length - 1].getPath().pop();
              this.removeDialog();
            }
          );
        }, 100);
      }
    }
  }

  rightClickMap(e) {
    this.newPolyLine = true;
  }

  generatePDF() {
    var polyLines = [];
    var bounds = new google.maps.LatLngBounds();

    // Collect all of the points for the lines
    for (var i = 0; i < this.polyLines.length; i++) {
      let segments = [];
      var path = this.polyLines[i].getPath();
      for (var j = 0; j < path.length; j++) {
        bounds.extend(path.getAt(j));
        segments.push([path.getAt(j).lat(), path.getAt(j).lng()]);
      }
      polyLines.push(segments);
    }

    if (polyLines.length > 0) {
      this.turnOffDrawLines();
      this.generatedMaps = true;
      this.map.fitBounds(bounds);
      this.dialogTimeout = setTimeout(() => {
        this.showWindowDialog('', '', null, '', '', true, (doIt) => {});
        this.setDialogToLoader(
          'Generating a PDF of your TSL Map',
          'This may take a few minutes. You can wait for a link to your map here, but you will also receive a link sent to your email when it is completed.'
        );
      }, 500);

      let requestKey = FirebaseWorker.ref('photoheight/server_requests/penndot_relocations/generate_tsl/requests').push({
        polyLines: JSON.stringify(polyLines),
        email: firebase.auth().currentUser.email
      }).key;

      FirebaseWorker.ref(`photoheight/server_requests/penndot_relocations/generate_tsl/responses/${requestKey}`).on('value', (s) => {
        if (s.val()) {
          let response = s.val();
          s.ref.remove();

          if (this.dialogTimeout) clearTimeout(this.dialogTimeout);
          this.removeDialog();

          if (response.status.toLowerCase() == 'success') {
            this.showWindowMessage(response, '#0053a0');
          } else if (response.status.toLowerCase() == 'error') {
            this.showWindowMessage(response, '#f79100');
          }
          if (response.pages) {
            for (var i = 0; i < response.pages.length; i++) {
              this.map.data.addGeoJson(response.pages[i]);
            }
          }
          if (response.envelope) {
            this.map.data.addGeoJson(response.envelope, { fillColor: 'blue', fillOpacity: 0.6, strokeColor: 'blue' });
          }
          if (response.buffer) {
            this.map.data.addGeoJson(response.buffer, { fillColor: 'green', fillOpacity: 0.6, strokeColor: 'green' });
          }
        }
      });
    } else {
      this.drawLinesMode = false;
      this.drawLinesToggle();
    }
  }

  // todo this might not work right with the query selector

  getByClass(className, parent) {
    if (!parent) {
      parent = this.shadowRoot;
    }
    var split = className.split(' ');
    var query = '';
    for (var i = 0; i < split.length; i++) {
      query += '.' + split[i];
    }
    return parent.querySelectorAll(query);
  }

  showMapMessage(text, icon) {
    var mapMessage = document.createElement('div');
    mapMessage.id = 'mapMessage_' + this.increment++;
    mapMessage.className = 'mapMessage';
    var mapMessageText = document.createElement('div');
    mapMessageText.className = 'mapMessageText';
    mapMessageText.innerHTML = text;
    mapMessage.appendChild(mapMessageText);
    if (icon != null) {
      mapMessageText.style.width = '184px';
      var mapMessageIcon = document.createElement('img');
      mapMessageIcon.className = 'mapMessageIcon';
      mapMessageIcon.src = icon;
      mapMessage.appendChild(mapMessageIcon);
    }
    this.shadowRoot.querySelector('#messageContainer').appendChild(mapMessage);
    setTimeout(() => {
      mapMessage.style.marginBottom = '0';
      mapMessage.style.opacity = 1;
    }, 100);
  }

  clearMessages() {
    var messages = this.getByClass('mapMessage');
    var messageIds = [];
    for (var i = 0; i < messages.length; i++) {
      messageIds.push(messages[i].id);
    }
    setTimeout(() => {
      for (var i = 0; i < messageIds.length; i++) {
        var message = this.shadowRoot.querySelector('#' + messageIds[i]);
        if (message != null) {
          message.style.opacity = 0;
        }
      }
    }, 200);
    setTimeout(() => {
      for (var i = 0; i < messageIds.length; i++) {
        var message = this.shadowRoot.querySelector('#' + messageIds[i]);
        if (message != null) {
          message.parentNode.removeChild(message);
        }
      }
    }, 500);
  }
}
window.customElements.define(TSLMapsGenerator.is, TSLMapsGenerator);
